export const CONTEXT_READY = 'ready';
export const CONTEXT_PENDING = 'pending';
export const CONTEXT_FAILED = 'failed';
export const CONTEXT_BUSY = 'busy';
export type CONTEXT_STATUSES =
  | typeof CONTEXT_READY
  | typeof CONTEXT_PENDING
  | typeof CONTEXT_FAILED
  | typeof CONTEXT_BUSY;
